import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import styles from './NotFound.module.scss';
import { Helmet } from 'react-helmet';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found - Yesterday Stories</title>
        <meta name="description" content="The page you're looking for doesn't exist. Return to Yesterday Stories homepage." />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      {/* Add spacing for fixed header */}
      <br/><br/><br/><br/><br/><br/><br/>
      
      <div className={styles.notFoundWrapper}>
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <div className={styles.notFoundContent}>
                <div className={styles.errorCode}>404</div>
                <h1 className={styles.errorTitle}>Page Not Found</h1>
                <p className={styles.errorDescription}>
                  Sorry, we couldn't find the page you're looking for. 
                  The page might have been moved, deleted, or the URL might be incorrect.
                </p>
                
                <div className={styles.actionButtons}>
                  <Link to="/" className={styles.homeButton}>
                    ← Return to Homepage
                  </Link>
                </div>
                
                <div className={styles.contactSection}>
                  <p>Still can't find what you're looking for?</p>
                  <a href="mailto:info@yesterdaystories.com.au" className={styles.contactLink}>
                    info@yesterdaystories.com.au
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default NotFound;